import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from 'react';
import { _postURL } from "@/api/index";
import { pagelink } from "@/config/site";
import { FaCog } from 'react-icons/fa';

export default function Index(props) {
    const { t, type } = props; // type is passed from getServerSideProps below
    const [checkoutType, setCheckoutType] = useState(type);
    let nominee_link; let list_link;

    if(process.env.NEXT_PUBLIC_ENV == 'dev'){   // dev
        // Nominee payment link ( usd 500 )
        nominee_link = 'https://buy.stripe.com/test_28o8xqamg9N3cMg5kk';

        // Sponsorship payment link ( usd 2000 )
        list_link = 'https://buy.stripe.com/test_cN23d6dys0ct5jO9AB';
    }
    else{   // live
        // Nominee payment link ( usd 500 )
        nominee_link = 'https://buy.stripe.com/7sI29QbBVcPwdWw4gg';

        // Sponsorship payment link ( usd 2000 )
        list_link = 'https://buy.stripe.com/fZe6q635p5n4dWw9AB';
    }

    useEffect(() => {
        // type 1 is nominee, type 2 is list
        if(checkoutType.params.type == 1){
            setTimeout(function(){
                window.location = nominee_link;
            }, 2000);
        }
        else if(checkoutType.params.type == 2){
            setTimeout(function(){
                window.location = list_link;
            }, 2000);
        }
        else{
            setTimeout(function(){
                window.location = pagelink.general.pageNotFound;
            }, 2000);
        }
    }, []);

    const style = {

    }
    return (<>
        <div style={{ backgroundImage: 'linear-gradient(rgba(255, 247, 232) 0%, rgb(255, 255, 255, 0) 30%)', backgroundRepeat: 'no-repeat' }}>
            <div style={{ paddingTop: '40vh', textAlign: 'center', height: '100vh', position: 'relative' }}>
                <span style={{ fontSize: '30px', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {t('Loading_payment_page')} &nbsp;<FaCog className='fa-spin'/>
                </span>
                {t('Please_hold_on')}...
                <div style={{ position: 'absolute', bottom: '20px', left: 0, right: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <a href={pagelink.home.homepage}>
                        <img src="/assets/images/logo.png" alt="" style={{ maxWidth: '100%', height: 'auto', width: '150px' }} />
                    </a>
                    <span style={{ fontSize: '12px', paddingTop: '10px' }}>Copyright &#169; 2022 Ugrado.com. All Rights Reserved.</span>
                </div>
            </div>
        </div>
    </>);
}

Index.getLayout = function getLayout(page) {
    return ( 
        <>
            {page}
        </>
    )
}

export async function getServerSideProps ({ req, res, locale, params }) {
    if(params.type != '1' && params.type != '2'){
        return {
            notFound: true
        }
    }

    return {
        props: {
            type: {
                params
            },
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}